/* eslint-disable import/prefer-default-export */

export const SELECT_MANY = 0;
export const CRAFT_EMAIL = 1;
export const SUCCESSFUL_SHARE = 2;
